<template>
<html data-wf-page="5b6395dd4555cf0b42389efd" data-wf-site="5b6395dd4555cf07a7389efc">
<head>
  <meta charset="utf-8">
  <title>Brother58 Chicago</title>
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body>
  <div data-collapse="medium" data-animation="default" data-duration="400" class="navbar w-nav">
    <div class="div-block-3">
      <div class="div-block-2"><a href="#" class="brand w-nav-brand">
        <img src="../../public/images/58brother logo.png" height="62" sizes="95.375px" class="image-2"></a>
        <nav role="navigation" class="nav-menu w-nav-menu">
          <a @click="currentComponent = 'orders'" href="#" :class="currentComponent === 'orders' ? 'chosen' : 'nav-link-2 w-nav-link'">Dashboard</a>
          <a @click="currentComponent = 'home-form'"  href="#" :class="currentComponent === 'home-form' ? 'chosen' : 'nav-link-2 w-nav-link'">Shipping</a>
          <a @click="currentComponent = 'tracking'" href="#" :class="currentComponent === 'tracking' ? 'chosen':'nav-link-2 w-nav-link'">Tracking</a>
          <a @click="currentComponent = 'support'" href="#" :class="currentComponent === 'support' ? 'chosen' : 'nav-link-2 w-nav-link'">Support</a>
        </nav>
      </div>
      <div class="div-block w-hidden-medium w-hidden-small w-hidden-tiny"><img src="../../public/images/baseline_account_circle_white_18dp.png" width="36" class="image">
        <div data-delay="0" class="w-dropdown">
          <div class="dropdown-toggle w-dropdown-toggle" @click="dropdown">
            <div class="icon-2 w-icon-dropdown-toggle"></div>
            <div class="text-block"> {{ userEmail }} </div>
          </div>
          <nav class="dropdown-list-2 w-dropdown-list" v-show="dropdownOpen">
            <a href="#" @click="currentComponent = 'profile', dropdownOpen = false" :class="currentComponent === 'profile' ? 'chosen1':'dropdown-link-5 w-dropdown-link'">Profile</a>
            <a href="#" @click="currentComponent = 'address-book', dropdownOpen = false" :class="currentComponent === 'address-book' ? 'chosen1':'dropdown-link-6 w-dropdown-link'">Address Book</a>
            <!-- <a href="#" @click="currentComponent = 'promotion', dropdownOpen = false" :class="currentComponent === 'promotion' ? 'chosen1':'dropdown-link-7 w-dropdown-link'">Promotion</a> -->
            <a href="#" @click="signOut" class="dropdown-link-8 w-dropdown-link">Sign Out</a>
          </nav>
        </div>
      </div>
      <div class="menu-button w-nav-button" @click="openNavMenu = !openNavMenu">
        <div class="icon w-icon-nav-menu"></div>
      </div>
    </div>
    <div class='mobile-menu' style="width:100%; display:flex; flex-direction:column">
      <div v-show="openNavMenu" class="mobile-menu-1">
          <a style="width: 100%; cursor: pointer" @click="currentComponent = 'orders', openNavMenu = false" :class="currentComponent === 'orders' ? 'chosen' : 'nav-link w-nav-link'">Dashboard</a>
          <a style="width: 100%" @click="currentComponent = 'home-form', openNavMenu = false" :class="currentComponent === 'home-form' ? 'chosen' : 'nav-link-2 w-nav-link'">Shipping</a>
          <a style="width: 100%" href="#" @click="currentComponent = 'tracking', openNavMenu = false" :class="currentComponent === 'tracking' ? 'chosen':'nav-link-2 w-nav-link'">Tracking</a>
          <a style="width: 100%" href="#" @click="currentComponent = 'support', openNavMenu = false" :class="currentComponent === 'support' ? 'chosen' : 'nav-link-3 w-nav-link'">Support</a>
          <div style="width: 100%" data-delay="0" class="dropdown w-dropdown">
            <div class="dropdown-toggle-2 w-hidden-main w-dropdown-toggle" @click="dropdownMobile">
              <div class="icon-3 w-icon-dropdown-toggle"></div>
              <div class="text-block-2">My Account</div>
            </div>
            <nav class="dropdown-list w-dropdown-list" v-show="dropdownOpenMobile">
              <a href="#" @click="currentComponent = 'profile', openNavMenu = false" :class="currentComponent === 'profile' ? 'chosen1':'dropdown-link w-dropdown-link'">Profile</a>
              <a href="#" @click="currentComponent = 'address-book', openNavMenu = false" :class="currentComponent === 'address-book' ? 'chosen1':'dropdown-link-2 w-dropdown-link'">Address Book</a>
              <!-- <a href="#" @click="currentComponent = 'promotion', openNavMenu = false" :class="currentComponent === 'promotion' ? 'chosen1':'dropdown-link-3 w-dropdown-link'">Promotions</a> -->
              <a href="#" @click="signOut" class="dropdown-link-4 w-dropdown-link">Sign Out</a>
            </nav>
          </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="content-block">
      <orders
        v-show="currentComponent === 'orders'"
        v-on:to-shipping="currentComponent = 'home-form'"
        :user="user"/>
      <home-form
        v-show="currentComponent === 'home-form'"
        v-on:to-homepage="currentComponent = 'orders'"
        :user="user"
        :stores="stores"/>
      <tracking v-show="currentComponent === 'tracking'"/>
      <support v-show="currentComponent === 'support'" :user="user" :stores="stores"/>
      <profile v-show="currentComponent === 'profile'" :user="user"/>
      <address-book v-show="currentComponent === 'address-book'" :user="user"/>
      <!-- <promotion v-show="currentComponent === 'promotion'"/> -->
    </div>
  </div>
  <div class="section-2">
    <div class="text-block-3">Powered By </div>
    <a href="https://studioscreation.com" target="_blank" class="link-block w-inline-block">
      <div class="text-block-4">Studio S</div>
    </a>
  </div>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">
  WebFont.load({
    google: {
      families: ["Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic"]
    }
  });
</script>
<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">
  ! function(o, c) {
    var n = c.documentElement,
    t = " w-mod-";
    n.className += t + "js", ("ontouchstart" in o || o.DocumentTouch && c instanceof DocumentTouch) && (n.className += t + "touch")
  }(window, document);
</script>
<script>
/* eslint-disable handle-callback-err */

import firebase from 'firebase/app'
import 'firebase/auth'

import Orders from '@/components/Orders'
import HomeForm from '@/components/HomeForm'
import Tracking from '@/components/Tracking'
import Support from '@/components/Support'
import Profile from '@/components/Profile'
import AddressBook from '@/components/AddressBook'
import Promotion from '@/components/Promotion'

export default {
  name: 'Dashboard',
  props: ['user', 'stores'],
  data () {
    return {
      openNavMenu: false,
      currentComponent: 'orders',
      dropdownOpen: false,
      dropdownOpenMobile: false,
    }
  },
  computed: {
    userEmail: function () {
      if (this.user !== null) {
        return this.user.email
      } else {
        return 'Login'
      }
    }
  },
  methods: {
    dropdown: function () {
      this.dropdownOpen = !this.dropdownOpen
    },
    dropdownMobile: function () {
      this.dropdownOpenMobile = !this.dropdownOpenMobile
    },
    signOut: function () {
      let that = this
      // console.log('signing out')
      firebase.auth().signOut()
      .then(() => {
        that.$emit('log-out')
      })
      .catch(err => {
        // console.log(err)
      })
    }
  },
  components: {
    Orders, HomeForm, Tracking, Support, Profile, AddressBook, Promotion
  }
}
</script>

<style>
.chosen {
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  transition: all 0.2s ease;
  color: #fa0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}
.chosen1 {
  color: #fa0;
  position: relative;
  text-decoration: none;
  padding: 10px 20px;
  display: block;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
}
@media (min-width: 992px) {
  .mobile-menu {
    display: none;
  }
  .mobile-menu-1 {
   height: 0;
   opacity: 0;
  }
}
</style>
